import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import tick from '../Assets/yes-alt-svgrepo-com (2) 53.png'
import img from '../Assets/123.png'
import img2 from '../Assets/Group 1000005998.png'
import img3 from '../Assets/Group 1000005999.png'
import img4 from '../Assets/Group 1000006000.png'
import icon from '../Assets/ixon (1).png'
import icon2 from '../Assets/ixon (2).png'
import icon3 from '../Assets/ixon (3).png'
import icon4 from '../Assets/ixon (4).png'
import SEOData from '../Components/SEOData'

function About() {
    return (
        <>
            <Navbar />
            <SEOData PageName={'about'} />
            <div className='banner2'>
                <h4>About Us</h4>
                <h2>About Hostess</h2>
                <p>Home - About Us</p>

            </div>
            <div className='Lovebetter'>
                <div className='Lovebetter-left'>
                    <h3>Love better with the best advice</h3>
                    <br />
                    <p>Our expert team provides personalized guidance and valuable insights to help you build deeper, more meaningful relationships. Whether you're looking to improve communication, overcome challenges, or enhance intimacy, we offer tailored advice to suit your unique needs. With our support, you’ll strengthen your connection, foster trust, and create lasting, enriched relationships built on mutual understanding and love.</p>
                    <br />
                    <br />
                    <div className='Lovebetter-righttick'>
                        <h2>
                            <img src={tick} />
                            We are formed your love life
                        </h2>

                    </div>
                    <br />
                    <div className='line'></div>
                    <br />
                    <div className='Lovebetter-righttick'>
                        <h2>
                            <img src={tick} />
                            Worlds best place for dating consultation
                        </h2>

                    </div>
                    <br />
                    <div className='line'></div>
                    <br />
                    <div className='Lovebetter-righttick'>
                        <h2>
                            <img src={tick} />
                            Together we can prevent your dating
                        </h2>

                    </div>

                </div>
                <div className='Lovebetter-right'>
                    <img src={img} />

                </div>

            </div>
            <div className='Whywe'>
                <div className='Whywe-left'>
                    <img src={img2} />

                </div>
                <div className='Whywe-right'>
                    <h3>Why we're here</h3>
                    <br />
                    <br />
                    <p>LoveDate was founded by three sisters who believe everyone deserves a real chance at love. Frustrated by the superficiality of casual swiping apps, they set out to create a platform that fosters genuine connections. Our mission is to bring people together based on shared values, meaningful conversations, and authentic chemistry. We understand that true love is built on more than just pictures and profiles, which is why we focus on compatibility, emotional connection, and long-term happiness. With LoveDate, we’re committed to helping you find love that lasts—one real connection at a time.
                    </p>
                    <br />
                    <br />

                    <div className='day-box'>
                        <div className='day-box-div'>
                            <h4>238K</h4>
                            <h6>Match per day</h6>
                        </div>
                        <div className='day-box-div'>
                            <h4>238K</h4>
                            <h6>Match per day</h6>
                        </div>
                    </div>
                </div>

            </div>
            <div className='Whywe'>

                <div className='Whywe-right'>
                    <h3>Real love stories <br />last forever</h3>
                    <br />
                    <br />
                    <p>More than 8 million stories have Started on LoveDate**
                        Our favorite stories to read? Without hesitation, yours!
                        Each meeting told with your own words is unique, funny, moving. They are proof that making online dating between singles pre -pre -to -commit to commit In a real story, it does happen every day On LoveDate.
                    </p>

                </div>
                <div className='Whywe-left'>
                    <img src={img3} />

                </div>

            </div>
            <div className='drive drive1'>
                <div className='drive-left'>
                    <img src={img4} />

                </div>
                <div className='drive-right'>
                    <h3>Driven by talent, enabled <br />by strategy</h3>
                    <p>At the heart of our success lies a team of talented individuals whose skills, creativity, and passion drive everything we do. Our strategic approach harnesses this talent, ensuring that every move we make is purposeful, efficient, and aligned with long-term goals. By combining expertise with well-thought-out strategies, we unlock opportunities, overcome challenges, and deliver exceptional results. Talent fuels our innovation, while strategy transforms it into lasting impact.</p>
                </div>

                <br />
                <br />
                <br />

            </div>
            {/* <div className='drive'>
        <h3>Why Hostess?</h3>
        <br/>
        <br/>
        <br/>
    <div className='drive-div'>
    <div className='drive-card'>
    <img src={icon}/>
    <p>Awesome Community</p>

</div>
 <div className='drive-card'>
    <img src={icon2}/>
    <p>Million Members</p>

</div>
 <div className='drive-card'>
    <img src={icon3}/>
    <p>Private Groups</p>

</div>
 <div className='drive-card'>
    <img src={icon4}/>
    <p>Friendly Forums</p>

</div>
    </div>

        </div> */}
            <Footer />
        </>
    )
}

export default About